import React, { useEffect, useState } from 'react';
import api from '../services/api';

const REQUIRED_CODES = [
  'a1','freistellung','bozp','posted_worker','poistka','scc_vca','vyhlaska','preukaz','preukaz_plosiny','preukaz_vysokozdvizny','zvaracsky_preukaz','vodicsky_preukaz'
];

const ProjectRequiredDocs = ({ projectId, canEdit }) => {
  const [types, setTypes] = useState([]);
  const [reqMap, setReqMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/projects/${projectId}/required-documents`);
        setTypes(data.requirements || []);
        const map = {};
        (data.requirements || []).forEach(r => { map[r.code] = !!r.required; });
        setReqMap(map);
      } catch (e) {
        // ignore
      } finally {
        setLoading(false);
      }
    })();
  }, [projectId]);

  const toggle = (code) => {
    if (!canEdit) return;
    setReqMap(prev => ({ ...prev, [code]: !prev[code] }));
  };

  const save = async () => {
    try {
      const payload = { requirements: types.filter(t => REQUIRED_CODES.includes(t.code)).map(t => ({ type_code: t.code, required: !!reqMap[t.code] })) };
      await api.put(`/projects/${projectId}/required-documents`, payload);
      alert('Požadované dokumenty uložené');
    } catch (e) {
      alert('Chyba pri uložení: ' + (e.response?.data?.error || e.message));
    }
  };

  if (loading) return <div>Načítavam požiadavky na dokumenty...</div>;

  const listed = types.filter(t => REQUIRED_CODES.includes(t.code));

  return (
    <div style={{ border:'1px solid #e9ecef', padding:'10px', borderRadius:'6px', marginTop:'10px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <h4 style={{ margin:0 }}>📄 Požadované dokumenty</h4>
        {canEdit && (
          <button type="button" onClick={save}>Uložiť</button>
        )}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'8px', marginTop:'10px' }}>
        {listed.map(t => (
          <label key={t.code} style={{ display:'flex', alignItems:'center', gap:'8px' }}>
            <input type="checkbox" checked={!!reqMap[t.code]} onChange={() => toggle(t.code)} disabled={!canEdit} />
            <span>{t.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ProjectRequiredDocs;
